export type ChartColorScheme = 'dark' | 'light';

const PRODUCT_CHART_COLORS: Record<ChartColorScheme, Record<string, string>> = {
  dark: {
    HYDROGEL_PACK: '#2ee98c',
    VELVETFRUIT_EXTRACT: '#ff5c7a',
    VEV_4000: '#6ea8ff',
    VEV_4500: '#ffb020',
    VEV_5000: '#b277ff',
    VEV_5100: '#22d3ee',
    VEV_5200: '#34d399',
    VEV_5300: '#ff6b6b',
    VEV_5400: '#8b8cff',
    VEV_5500: '#f97316',
    VEV_6000: '#d946ef',
    VEV_6500: '#06b6d4',
  },
  light: {
    HYDROGEL_PACK: '#078a49',
    VELVETFRUIT_EXTRACT: '#d7264f',
    VEV_4000: '#2f6fd6',
    VEV_4500: '#b86b00',
    VEV_5000: '#7a3fe0',
    VEV_5100: '#008aa8',
    VEV_5200: '#148a5a',
    VEV_5300: '#c93434',
    VEV_5400: '#4f56d8',
    VEV_5500: '#c45700',
    VEV_6000: '#a21caf',
    VEV_6500: '#027fa0',
  },
};

const FALLBACK_CHART_COLORS: Record<ChartColorScheme, string[]> = {
  dark: [
    '#2ee98c',
    '#ff5c7a',
    '#6ea8ff',
    '#ffb020',
    '#b277ff',
    '#22d3ee',
    '#34d399',
    '#ff6b6b',
    '#8b8cff',
    '#f97316',
    '#d946ef',
    '#06b6d4',
    '#facc15',
    '#fb7185',
    '#60a5fa',
    '#c084fc',
  ],
  light: [
    '#078a49',
    '#d7264f',
    '#2f6fd6',
    '#b86b00',
    '#7a3fe0',
    '#008aa8',
    '#148a5a',
    '#c93434',
    '#4f56d8',
    '#c45700',
    '#a21caf',
    '#027fa0',
    '#a16207',
    '#be123c',
    '#1d4ed8',
    '#7e22ce',
  ],
};

export function getBidColor(alpha: number): string {
  return `rgba(39, 174, 96, ${alpha})`;
}

export function getAskColor(alpha: number): string {
  return `rgba(192, 57, 43, ${alpha})`;
}

export function getProductChartColor(product: string, index = 0, colorScheme: ChartColorScheme = 'light'): string {
  return PRODUCT_CHART_COLORS[colorScheme][product] ?? FALLBACK_CHART_COLORS[colorScheme][index % FALLBACK_CHART_COLORS[colorScheme].length];
}
